import { cva } from "class-variance-authority";

export const toastVariants = cva(
  [
    "group pointer-events-auto relative flex w-full items-center justify-between space-x-2 overflow-hidden rounded-md border px-3 pr-6 shadow-lg transition-all",
    "data-[state=closed]:slide-out-to-right-full ",
    "data-[state=open]:slide-in-from-right-full",
    "data-[state=open]:sm:slide-in-from-right-full",
    "data-[swipe=end]:animate-out data-[state=closed]:fade-out-80",
    "data-[state=open]:animate-in data-[state=closed]:animate-out",
    "data-[swipe=move]:transition-none",
    "data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)]",
    "data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)]",
    "data-[swipe=cancel]:translate-x-0",
  ],
  {
    variants: {
      variant: {
        default: "border bg-background text-foreground",
        destructive: "destructive group border-yellow-500 bg-white",
        success: "border bg-green-50 border-green-200 rounded-sm [&button]:text-gray-0",
        error: "border bg-red-50 border-red-200 rounded-sm [&button]:text-gray-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);
